module.exports = __webpack_public_path__ + "img/118.fcd7b0fe.jpg";